import React, { useState, useEffect } from 'react'
import { useFormik } from 'formik'
import 'containers/Time/Components/EventForm.scss'
import { Col, Row, Button } from 'reactstrap'

import { getFrench } from 'containers/Time/Components//FrenchTranslation'
import Modal from '@mui/material/Modal'
import Typography from '@mui/material/Typography'
import { Box, useMediaQuery, useTheme } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { isEmpty } from 'lodash'
import { makeGetRequest } from 'utils/api'
import { Checkbox, FormControl, ListItemText, MenuItem, OutlinedInput, Select } from '@mui/material'
import urls from 'utils/urls'
import { makePostRequest } from 'utils/api'
import { toast } from 'react-toastify'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  // maxWidth: '800px',
  height: 'fit-content',
  maxHeight: '80%',
  bgcolor: 'background.paper',
  boxShadow: 24,
  // minWidth: 800,
  borderRadius: 2,
  // pt: 2,
  // pb: 2,
}
const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
}
const CreateEvent = ({ toggleModal, editMode = false, title }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [categoryDD, setCategoryDD] = useState([])
  const [typeDD, setTypeDD] = useState([])
  const [value, setValue] = useState({})
  const [showStartDate, setShowStartDate] = useState(!editMode)
  const [showStartTime, setShowStartTime] = useState(!editMode)
  const [showEndDate, setShowEndDate] = useState(!editMode)
  const [showEndTime, setShowEndTime] = useState(!editMode)
  const [showLocation, setShowLocation] = useState(!editMode)
  const [showTitle, setShowTitle] = useState(!editMode)
  const [isPeriodic, setisPeriodic] = useState(false)
  const [isDaily, setisDaily] = useState(false)
  const [isMonthly, setisMonthly] = useState(false)
  const [isWeekly, setisWeekly] = useState(false)
  const [isYearly, setisYearly] = useState(false)
  const [personName, setPersonName] = React.useState([])
  const [contacts, setContacts] = useState([])

  const handleChange = (event) => {
    const {
      target: { value },
    } = event
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    )

    formik.setFieldValue('participants', typeof value === 'string' ? value.split(',') : value)
  }

  useEffect(() => {
    fetchCategoryDD()
    fetchContacts()
  }, [])
  const fetchContacts = async () => {
    const url = urls.getAllContacts + '?limit=100000'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterTypes = []
      data.forEach((v) => {
        filterTypes.push({ label: `${v.Nom} ${v.Prenom}`, id: v.id })
      })
      setContacts([...filterTypes])
    }
  }
  const fetchCategoryDD = async () => {
    const { data = {} } = await makeGetRequest('/api/time/get-category-dd', {}, true)
    setCategoryDD(data)
  }
  const validate = (values) => {
    const errors = {}
    if (!values.titre) {
      errors.titre = 'Required'
    } else if (values.titre.length > 255) {
      errors.titre = 'Must be 255 characters or less'
    }

    if (!values.lieux) {
      errors.lieux = 'Required'
    } else if (values.lieux.length > 50) {
      errors.lieux = 'Must be 20 characters or less'
    }

    if (!values.start_date) {
      errors.start_date = 'Required'
    }

    if (!values.end_date) {
      errors.end_date = 'Required'
    }
    return errors
  }
  useEffect(() => {
    const uFunction = async () => {
      setValue({
        start_date: '',
        end_date: '',
        start_time: null,
        end_time: null,
        titre: '',
        lieux: '',
        is_all_day: false,
        category_id: '',
        type_id: '',
        participants: [],
        saturday: false,
        sunday: false,
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        is_yearly: false,
        is_monthly: false,
        is_daily: false,
        is_weekly: false,
        is_periodic: false,
        repeat_on_month: null,
      })
    }
    uFunction()
  }, [])

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: value,
    validate,
    onSubmit: async (values) => {
      let payload = { ...values }
      const response = await makePostRequest('/api/time/events/', payload, {}, true)
      if (response.status === 201) {
        toast(`Event for ${title} successfully created`, {
          position: 'top-right',
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          theme: 'dark',
          pauseOnFocusLoss: false,
        })
        toggleModal()
      } else {
        toggleModal()
      }
    },
  })

  const getTypeByCategory = (id) => {
    let types = categoryDD.find((x) => x.id.toString() === id)
    types && setTypeDD(types.type)
  }

  useEffect(() => {
    value && value.category_id && getTypeByCategory(value.category_id.toString())
  }, [value])

  return (
    <Modal
      open={true}
      sx={{
        ...style,
        overflowY: 'scroll',
        '::-webkit-scrollbar': {
          display: 'none',
        },
        width: isMobile ? '90%' : '500px',
      }}
      // size={isMobile ? 'sm' : 'lg'}
    >
      <Box sx={{ pb: 2 }} className="adacontact">
        <Box
          sx={{
            textAlign: 'end',
            padding: '5px 10px',
            position: 'relative',
            zIndex: '9999',
            display: 'flex',
            justifyContent: 'space-between',
            background: 'black',
          }}
        >
          <Typography
            id="modal-modal-title"
            sx={{ color: 'white !important' }}
            variant="h6"
            component="h3"
          >
            Add Event
          </Typography>
          <CloseIcon sx={{ cursor: 'pointer', color: 'white' }} onClick={() => toggleModal()} />
        </Box>
        <form
          onSubmit={formik.handleSubmit}
          style={{
            backgroundColor: 'white',
            fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
            padding: '10px 15px',
          }}
        >
          <Row sx={{ marginTop: '15px' }}>
            <Col md={4}>
              <label htmlFor="titre">Titre</label>
            </Col>
            <Col md={6}>
              {showTitle && (
                <input
                  required
                  id="titre"
                  name="titre"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.titre}
                  placeholder={'Titre'}
                />
              )}
            </Col>
          </Row>
          {formik.errors.titre ? <div>{formik.errors.titre}</div> : null}
          <br />
          <Row>
            <Col md={4}>
              <label htmlFor="lieux">Lieux</label>
            </Col>
            <Col md={6}>
              {showLocation && (
                <input
                  id="lieux"
                  name="lieux"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.lieux}
                  placeholder={'Lieux'}
                />
              )}
            </Col>
          </Row>
          {formik.errors.lieux ? <div>{formik.errors.lieux}</div> : null}
          <br />
          <Row>
            <Col md={4}>
              <label htmlFor="start_date">Date de début</label>
            </Col>
            <Col md={6}>
              {showStartDate && (
                <input
                  id="start_date"
                  name="start_date"
                  type="date"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.start_date}
                />
              )}
            </Col>
          </Row>
          {formik.errors.start_date ? <div>{formik.errors.start_date}</div> : null}
          <br />
          <Row>
            <Col md={4}>
              <label htmlFor="start_time">Heure de début</label>
            </Col>
            <Col md={6}>
              {showStartTime && (
                <input
                  id="start_time"
                  name="start_time"
                  type="time"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.start_time}
                />
              )}
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={4}>
              <label htmlFor="end_date">Date de fin</label>
            </Col>
            <Col md={6}>
              {showEndDate && (
                <input
                  id="end_date"
                  name="end_date"
                  type="date"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.end_date}
                />
              )}
            </Col>
          </Row>
          {formik.errors.end_date ? <div>{formik.errors.end_date}</div> : null}
          <br />
          <Row>
            <Col md={4}>
              <label htmlFor="end_time">Heure de fin</label>
            </Col>
            <Col md={6}>
              {showEndTime && (
                <input
                  id="end_time"
                  name="end_time"
                  type="time"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.end_time}
                />
              )}
            </Col>
          </Row>

          <br />

          <br />
          <Row>
            <Col md={4}>
              <label htmlFor="is_periodic">{getFrench('is_periodic')}</label>
            </Col>
            <Col md={6}>
              <input
                id="is_periodic"
                name="is_periodic"
                type="checkbox"
                onChange={(e) => {
                  formik.handleChange(e)
                  formik.setFieldValue('is_periodic', e.target.checked)
                  setisPeriodic(e.target.checked)
                  if (!e.target.checked) {
                    setisDaily(false)
                    setisMonthly(false)
                    setisWeekly(false)
                    setisYearly(false)
                  }
                }}
                onBlur={formik.handleBlur}
                checked={formik.values.is_periodic}
                className="chckbox"
              />
            </Col>
          </Row>
          {isPeriodic && (
            <>
              <hr />
              <p>Périodicité</p>{' '}
              <Row>
                <Col md={3}>
                  <input
                    id="is_daily"
                    name="is_daily"
                    type="checkbox"
                    onChange={(e) => {
                      formik.handleChange(e)
                      setisDaily(e.target.checked)
                      setisMonthly(false)
                      setisWeekly(false)
                      setisYearly(false)
                      formik.setFieldValue('is_daily', e.target.checked)
                      formik.setFieldValue('is_weekly', false)
                      formik.setFieldValue('is_monthly', false)
                      formik.setFieldValue('is_yearly', false)
                    }}
                    onBlur={formik.handleBlur}
                    checked={formik.values.is_daily}
                    className="chckbox"
                  />
                  <label htmlFor="is_daily">{getFrench('is_daily')}</label>
                </Col>
                <Col md={3}>
                  <input
                    id="is_weekly"
                    name="is_weekly"
                    type="checkbox"
                    onChange={(e) => {
                      formik.handleChange(e)
                      setisWeekly(e.target.checked)
                      setisMonthly(false)
                      setisDaily(false)
                      setisYearly(false)
                      formik.setFieldValue('is_weekly', e.target.checked)
                      formik.setFieldValue('is_daily', false)
                      formik.setFieldValue('is_monthly', false)
                      formik.setFieldValue('is_yearly', false)
                    }}
                    onBlur={formik.handleBlur}
                    checked={formik.values.is_weekly}
                    className="chckbox"
                  />
                  <label htmlFor="is_weekly">{getFrench('is_weekly')}</label>
                </Col>
                <Col md={3}>
                  <input
                    id="is_monthly"
                    name="is_monthly"
                    type="checkbox"
                    onChange={(e) => {
                      formik.handleChange(e)
                      setisMonthly(e.target.checked)
                      setisDaily(false)
                      setisWeekly(false)
                      setisYearly(false)
                      formik.setFieldValue('is_monthly', e.target.checked)
                      formik.setFieldValue('is_weekly', false)
                      formik.setFieldValue('is_daily', false)
                      formik.setFieldValue('is_yearly', false)
                    }}
                    onBlur={formik.handleBlur}
                    checked={formik.values.is_monthly}
                    className="chckbox"
                  />
                  <label htmlFor="is_monthly">{getFrench('is_monthly')}</label>
                </Col>
                <Col md={3}>
                  <input
                    id="is_yearly"
                    name="is_yearly"
                    type="checkbox"
                    onChange={(e) => {
                      formik.handleChange(e)
                      setisYearly(e.target.checked)
                      setisMonthly(false)
                      setisWeekly(false)
                      setisDaily(false)
                      formik.setFieldValue('is_yearly', e.target.checked)
                      formik.setFieldValue('is_weekly', false)
                      formik.setFieldValue('is_monthly', false)
                      formik.setFieldValue('is_daily', false)
                    }}
                    onBlur={formik.handleBlur}
                    checked={formik.values.is_yearly}
                    className="chckbox"
                  />
                  <label htmlFor="is_yearly">{getFrench('is_yearly')}</label>
                </Col>
              </Row>
              <hr />
            </>
          )}

          {isDaily && (
            <>
              <Row>
                <Col md={6}>
                  <input
                    id="is_repeat_after"
                    name="is_repeat_after"
                    type="checkbox"
                    onChange={(e) => {
                      formik.handleChange(e)
                      formik.setFieldValue('is_repeat_daily', !e.target.checked)
                    }}
                    onBlur={formik.handleBlur}
                    checked={
                      formik.values.repeat_after && formik.values.is_repeat_daily === false
                        ? true
                        : false
                    }
                    className="chckbox"
                  />
                  <label htmlFor="is_repeat_after">{'Tous Les'}</label>{' '}
                  <input
                    name="repeat_after_every"
                    type={'number'}
                    min={1}
                    onChange={(e) => {
                      formik.setFieldValue('is_repeat_after', true)
                      formik.setFieldValue('is_repeat_daily', false)
                      formik.setFieldValue('repeat_after', e.target.value)
                    }}
                    value={formik.values.is_repeat_daily === true ? '' : formik.values.repeat_after}
                  />{' '}
                  <label htmlFor="is_repeat_after">{'Jour(s)'}</label>
                </Col>
                <Col md={6}>
                  <input
                    id="is_repeat_daily"
                    name="is_repeat_daily"
                    type="checkbox"
                    onChange={(e) => {
                      formik.handleChange(e)
                      formik.setFieldValue('is_repeat_daily', e.target.checked)
                      formik.setFieldValue('is_repeat_after', !e.target.checked)
                      formik.setFieldValue('repeat_after', 1)
                    }}
                    onBlur={formik.handleBlur}
                    checked={formik.values.is_repeat_daily}
                    className="chckbox"
                  />
                  <label htmlFor="is_repeat_daily">{'Tous les jours de semaine'}</label>{' '}
                </Col>
              </Row>
              <hr />
            </>
          )}

          {isWeekly && (
            <>
              <Row>
                <Col md={12}>
                  <label htmlFor="is_repeat_after">{'Toutes les'}</label>{' '}
                  <input
                    name="repeat_after_every"
                    type={'number'}
                    min={1}
                    onChange={(e) => {
                      formik.setFieldValue('repeat_after', e.target.value)
                    }}
                    value={formik.values.repeat_after}
                  />{' '}
                  <label htmlFor="is_repeat_after">{'semaine(s) le:'}</label>
                </Col>
                <br />
                <br />
                <Col>
                  <Col md={12}>
                    <input
                      id="saturday"
                      name="saturday"
                      type="checkbox"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      checked={formik.values.saturday}
                      className="chckbox"
                    />
                    <label htmlFor="saturday">{getFrench('saturday')}</label>
                    <span style={{ marginLeft: '15px' }}>{''}</span>
                    <input
                      id="sunday"
                      name="sunday"
                      type="checkbox"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      checked={formik.values.sunday}
                      className="chckbox"
                    />
                    <label htmlFor="sunday">{getFrench('sunday')}</label>
                    <span style={{ marginLeft: '15px' }}>{''}</span>
                    <input
                      id="monday"
                      name="monday"
                      type="checkbox"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      checked={formik.values.monday}
                      className="chckbox"
                    />
                    <label htmlFor="monday">{getFrench('monday')}</label>
                    <span style={{ marginLeft: '15px' }}>{''}</span>
                    <input
                      id="tuesday"
                      name="tuesday"
                      type="checkbox"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      checked={formik.values.tuesday}
                      className="chckbox"
                    />
                    <label htmlFor="tuesday">{getFrench('tuesday')}</label>
                    <span style={{ marginLeft: '15px' }}>{''}</span>
                    <input
                      id="wednesday"
                      name="wednesday"
                      type="checkbox"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      checked={formik.values.wednesday}
                      className="chckbox"
                    />
                    <label htmlFor="wednesday">{getFrench('wednesday')}</label>
                    <span style={{ marginLeft: '15px' }}>{''}</span>
                    <input
                      id="thursday"
                      name="thursday"
                      type="checkbox"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      checked={formik.values.thursday}
                      className="chckbox"
                    />
                    <label htmlFor="thursday">{getFrench('thursday')}</label>
                    <span style={{ marginLeft: '15px' }}>{''}</span>
                    <input
                      id="friday"
                      name="friday"
                      type="checkbox"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      checked={formik.values.friday}
                      className="chckbox"
                    />
                    <label htmlFor="friday">{getFrench('friday')}</label>
                  </Col>
                </Col>
              </Row>
              <hr />
            </>
          )}
          {isMonthly && (
            <>
              <Row>
                <Col md={12}>
                  <label htmlFor="repeat_on">{'Le'}</label>
                  <span style={{ marginLeft: '10px' }}>{''}</span>
                  <input
                    name="repeat_on"
                    type={'number'}
                    min={1}
                    onChange={(e) => {
                      formik.handleChange(e)
                    }}
                    value={formik.values.repeat_on}
                  />{' '}
                  <label htmlFor="repeat_after">{'Tous Les'}</label>
                  <span style={{ marginLeft: '15px' }}>{''}</span>
                  <input
                    name="repeat_after"
                    type={'number'}
                    min={1}
                    onChange={(e) => {
                      formik.handleChange(e)
                    }}
                    value={formik.values.repeat_after}
                  />
                  <span style={{ marginLeft: '15px' }}>{''}</span>
                  <label htmlFor="repeat_after">{'Mois'}</label>
                </Col>
              </Row>
              <hr />
            </>
          )}
          {isYearly && (
            <>
              <Row>
                <Col md={12}>
                  <label>{'Toutes les'}</label>
                  <span style={{ marginLeft: '10px' }}>{''}</span>
                  <input
                    name="repeat_after"
                    type={'number'}
                    min={1}
                    onChange={(e) => {
                      formik.handleChange(e)
                    }}
                    value={formik.values.repeat_after}
                  />{' '}
                  <label>{'an(s)'}</label>
                </Col>
                <br />
                <br />
                <Col md={12}>
                  <label>{'Le:'}</label>
                  <span style={{ marginLeft: '15px' }}>{''}</span>
                  <input
                    name="repeat_on"
                    type={'number'}
                    min={1}
                    onChange={(e) => {
                      formik.handleChange(e)
                    }}
                    value={formik.values.repeat_on}
                  />
                  <span style={{ marginLeft: '15px' }}>{''}</span>
                  <select
                    id="repeat_on_month"
                    name="repeat_on_month"
                    type="select"
                    onChange={(e) => {
                      formik.handleChange(e)
                      formik.setFieldValue('repeat_on_month', e.target.value)
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.repeat_on_month}
                  >
                    <option value={1}>{getFrench(1)}</option>
                    <option value={4}>{getFrench(2)}</option>
                    <option value={3}>{getFrench(3)}</option>
                    <option value={6}>{getFrench(4)}</option>
                    <option value={5}>{getFrench(5)}</option>
                    <option value={6}>{getFrench(6)}</option>
                    <option value={7}>{getFrench(7)}</option>
                    <option value={8}>{getFrench(8)}</option>
                    <option value={9}>{getFrench(9)}</option>
                    <option value={10}>{getFrench(10)}</option>
                    <option value={11}>{getFrench(11)}</option>
                    <option value={12}>{getFrench(12)}</option>
                  </select>
                </Col>
              </Row>
              <hr />
            </>
          )}

          {(isDaily || isWeekly || isMonthly || isYearly) && (
            <>
              <Row>
                <p>{'Plage de périodicité'}</p>
                <Col md={12}>
                  <label>{'Début'}</label>
                  <span style={{ marginLeft: '15px' }}>{''}</span>
                  <input
                    disabled
                    id="start_date"
                    name="start_date"
                    type="date"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.start_date}
                  />
                </Col>
                <br />
                <br />

                <Col md={12}>
                  <input
                    id="is_freq_end_date"
                    name={'is_freq_end_date'}
                    type={'checkbox'}
                    className="chckbox"
                    onChange={(e) => {
                      formik.handleChange(e)
                      formik.setFieldValue('is_freq_end_date', true)
                      formik.setFieldValue('is_occurrences', false)
                      formik.setFieldValue('is_no_end_date', false)
                    }}
                    checked={formik.values.is_freq_end_date}
                  />
                  <label>{'Fin le'}</label>
                  <span style={{ marginLeft: '8px' }}>{''}</span>
                  <input
                    id="frequency_end_date"
                    name="frequency_end_date"
                    type="date"
                    onChange={(e) => {
                      formik.handleChange(e)
                      formik.setFieldValue('is_freq_end_date', true)
                      formik.setFieldValue('is_occurrences', false)
                      formik.setFieldValue('is_no_end_date', false)
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.frequency_end_date}
                  />
                  <span style={{ marginLeft: '20px' }}>{''}</span>
                  <input
                    id="is_occurrences"
                    name={'is_occurrences'}
                    type={'checkbox'}
                    className="chckbox"
                    checked={formik.values.is_occurrences}
                    onChange={(e) => {
                      formik.handleChange(e)
                      formik.setFieldValue('is_freq_end_date', false)
                      formik.setFieldValue('frequency_end_date', null)
                      formik.setFieldValue('is_occurrences', true)
                      formik.setFieldValue('is_no_end_date', false)
                    }}
                  />
                  <label htmlFor="is_occurrences">{'Fin apres:'}</label>
                  <span style={{ marginLeft: '8px' }}>{''}</span>
                  <input
                    id="number_of_occurrences"
                    name="number_of_occurrences"
                    type="number"
                    min={1}
                    onChange={(e) => {
                      formik.handleChange(e)
                      formik.setFieldValue('is_freq_end_date', false)
                      formik.setFieldValue('is_occurrences', true)
                      formik.setFieldValue('is_no_end_date', false)
                    }}
                    onBlur={formik.handleBlur}
                    value={
                      formik.values.number_of_occurrences === 0
                        ? ''
                        : formik.values.number_of_occurrences
                    }
                  />
                  <span style={{ marginLeft: '6px' }}>{''}</span>
                  <label htmlFor="number_of_occurrences">{'occurrences'}</label>
                  <br />
                  <br />
                  <input
                    id="is_no_end_date"
                    name={'is_no_end_date'}
                    type={'checkbox'}
                    className="chckbox"
                    onChange={(e) => {
                      formik.handleChange(e)
                      formik.setFieldValue('number_of_occurrences', 0)
                      formik.setFieldValue('is_freq_end_date', false)
                      formik.setFieldValue('is_occurrences', false)
                      formik.setFieldValue('is_no_end_date', true)
                      formik.setFieldValue('frequency_end_date', null)
                    }}
                    checked={formik.values.is_no_end_date}
                  />
                  <label htmlFor="is_no_end_date">{'Pas De Date De Fin'}</label>
                </Col>
              </Row>
              <hr />
            </>
          )}
          <br />
          <Row>
            <Col md={4}>
              <label htmlFor="is_all_day">Journée entière</label>
            </Col>
            <Col md={6}>
              <input
                id="is_all_day"
                name="is_all_day"
                type="checkbox"
                checked={formik.values.is_all_day}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.is_all_day}
                className="chckbox"
              />
            </Col>
          </Row>

          <br />
          <Row>
            <Col md={4}>
              <label htmlFor="category_id">Categorie</label>
            </Col>
            <Col md={6}>
              <select
                id="category_id"
                name="category_id"
                type="select"
                onChange={(e) => {
                  formik.handleChange(e)
                  getTypeByCategory(e.target.value)
                }}
                onBlur={formik.handleBlur}
                value={formik.values.category_id}
              >
                <option value={''}>Selcet Categorie</option>
                {categoryDD &&
                  categoryDD.map((cat) => {
                    return (
                      <option key={cat.id} value={cat.id.toString()}>
                        {cat.name}
                      </option>
                    )
                  })}
              </select>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={4}>
              <label htmlFor="type_id">Type</label>
            </Col>
            <Col md={6}>
              <select
                id="type_id"
                name="type_id"
                type="select"
                onLoad={() => value.category_id && getTypeByCategory(value.category_id.toString())}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.type_id}
              >
                {typeDD &&
                  typeDD.map((type) => {
                    return (
                      <option key={type.id} value={type.id}>
                        {type.name}
                      </option>
                    )
                  })}
              </select>
            </Col>
          </Row>

          <br />
          <Row>
            <Col md={4}>
              <label htmlFor="participants">Participants</label>
            </Col>
            <Col md={6}>
              <FormControl sx={{ m: 1, width: 300 }}>
                <Select
                  id="participants"
                  name="participants"
                  multiple
                  value={personName}
                  onChange={handleChange}
                  input={<OutlinedInput label="" />}
                  renderValue={(selected) =>
                    selected
                      .map(
                        (id) =>
                          contacts.length > 0 && contacts.find((name) => name.id === id).label,
                      )
                      .join(', ')
                  }
                  MenuProps={MenuProps}
                  size="small"
                  sx={{ width: '226px' }}
                >
                  {contacts.map((v) => (
                    <MenuItem key={v.id} value={v.id}>
                      <Checkbox checked={personName.includes(v.id)} />
                      <ListItemText primary={v.label} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Col>
          </Row>

          <br />
          <Button type="cancel" color="danger" size="lg" onClick={() => toggleModal()}>
            Annuler
          </Button>
          <Button type="submit" size="lg" style={{ backgroundColor: '#5D86CC' }}>
            Soumettre
          </Button>
          <br />
          <br />
        </form>
      </Box>
    </Modal>
  )
}

export default CreateEvent
